import { render, staticRenderFns } from "./ShippingGeneralSetting.vue?vue&type=template&id=38c22792&scoped=true&"
import script from "./ShippingGeneralSetting.vue?vue&type=script&lang=js&"
export * from "./ShippingGeneralSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShippingGeneralSetting.vue?vue&type=style&index=0&id=38c22792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c22792",
  null
  
)

export default component.exports